import script from "./DetailRequestWithoutBonification.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailRequestWithoutBonification.vue?vue&type=script&setup=true&lang=js"

import "./DetailRequestWithoutBonification.vue?vue&type=style&index=0&id=21ad2d96&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21ad2d96"]])

export default __exports__